import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                  菜单栏是否显示，默认false
 * alwaysShow: true              是否总是显示一级节点，默认false，子节点大于2时才显示，只有一个子节点时，子节点占位
 * redirect: noRedirect          配置为noRedirect ，面包屑中不能跳转
 * name:'router-name'            the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            配置为false，不会出现在面包屑中，默认true
    activeMenu: '/example/list'  默认选中的菜单
  }
 */

/**
 * 导航要出现在标签栏，需要配置：
 * 1.路由配置name属性，且对应组件增加name属性，二者必须一致，通常首字母大写
 * 2.路由meta中配置title属性，affix表示是否固定在标签栏
 */

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
    meta: {
      title: '登录'
    }
  }
];

// 需要通过权限控制菜单时，过滤asyncRoutes，动态加载，当前未使用权限
export const asyncRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    name: 'Home',
    path: '/home',
    component: () => import('@/views/home/home'),
    meta: {
      title: '首页'
    }
  },
  {
    name: 'Details',
    path: '/details',
    component: () => import('@/views/home/details'),
    meta: {
      title: '首页'
    }
  }
];

const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  // routes: constantRoutes
  routes: [...constantRoutes, ...asyncRoutes]
})

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router

